import { render, staticRenderFns } from "./TableContentCrewList.vue?vue&type=template&id=2a130656&scoped=true"
import script from "./TableContentCrewList.vue?vue&type=script&lang=js"
export * from "./TableContentCrewList.vue?vue&type=script&lang=js"
import style0 from "./TableContentCrewList.vue?vue&type=style&index=0&id=2a130656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a130656",
  null
  
)

export default component.exports